import OneTrustScript from './one-trust-script';
export default OneTrustScript;
